import type { RithumAgentOptionsResponse } from './types';

export const FALLBACK_OPTIONS: RithumAgentOptionsResponse = {
  agents: [
    { id: 'cursor', label: 'Cursor' },
    { id: 'github-copilot', label: 'GitHub Copilot' },
    { id: 'claude', label: 'Claude' },
  ],
  modelsByProvider: {
    cursor: ['auto', 'composer-2-fast', 'sonnet-4.6'],
    'github-copilot': ['auto', 'gpt-5.2-codex', 'sonnet-4.6'],
    claude: ['default', 'sonnet', 'opus', 'haiku', 'opusplan', 'sonnet[1m]', 'opus[1m]'],
  },
  agentNames: ['Default'],
};
